/* AQUON Ingredient Cards - click & drag horizontal scroll.
   Uses Pointer Events with setPointerCapture so drag stays reliable even when
   the pointer leaves the scroller or crosses native image-drag surfaces.
   Both left and right mouse buttons trigger the drag. Native touch swipe on
   mobile is preserved. */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 5;
  // Mouse / desktop / webview flip on CSS :hover; only touch devices tap-to-flip.
  var hoverFlip = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initScroller(el) {
    if (!el || el.dataset.aicDragInit === '1') return;
    el.dataset.aicDragInit = '1';

    var isDown = false;
    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    // Block native HTML5 image drag inside the scroller
    el.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
    });

    // Suppress context menu so right-click drag works without popup
    el.addEventListener('contextmenu', function (e) {
      if (moved) e.preventDefault();
    });

    el.addEventListener('pointerdown', function (e) {
      // Ignore touch/pen: native scroll handles those
      if (e.pointerType !== 'mouse') return;
      // Accept left (0) and right (2) mouse buttons
      if (e.button !== 0 && e.button !== 2) return;

      isDown = true;
      moved = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startScroll = el.scrollLeft;
      el.classList.add('is-dragging');
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
    });

    el.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) moved = true;
      el.scrollLeft = startScroll - dx;
      e.preventDefault();
    });

    function release(e) {
      if (!isDown || (e && e.pointerId !== pointerId)) return;
      isDown = false;
      el.classList.remove('is-dragging');
      try { el.releasePointerCapture(pointerId); } catch (err) {}
      pointerId = null;

      if (moved) {
        // Prevent the click / auxclick that follows a drag from firing on inner links
        var suppressClick = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          el.removeEventListener('click', suppressClick, true);
          el.removeEventListener('auxclick', suppressClick, true);
        };
        el.addEventListener('click', suppressClick, true);
        el.addEventListener('auxclick', suppressClick, true);
        // Fallback: clear the suppressor next tick if no click fires
        setTimeout(function () {
          el.removeEventListener('click', suppressClick, true);
          el.removeEventListener('auxclick', suppressClick, true);
        }, 0);
      }
    }

    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);
    el.addEventListener('lostpointercapture', release);

    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* 3D flip: front -> frosted detail back. Uses the drag suppressor above, so a
     drag never triggers a flip. Accessible: aria-expanded, inert on the hidden
     face, Escape closes, focus moves to close and back to front. */
  function initFlip(card) {
    if (hoverFlip) return;
    if (card.dataset.aicFlipInit === '1') return;
    var front = card.querySelector('[data-aic-front]');
    var back = card.querySelector('[data-aic-back]');
    var close = card.querySelector('[data-aic-close]');
    if (!front || !back) return;
    card.dataset.aicFlipInit = '1';
    function setFace(f) {
      card.classList.toggle('is-flipped', f);
      front.setAttribute('aria-expanded', f ? 'true' : 'false');
      back.setAttribute('aria-hidden', f ? 'false' : 'true');
      try { back.inert = !f; front.inert = f; } catch (e) {}
    }
    function open() { setFace(true); if (close) { try { close.focus({ preventScroll: true }); } catch (e) { close.focus(); } } }
    function shut() { setFace(false); try { front.focus({ preventScroll: true }); } catch (e) { front.focus(); } }
    setFace(false);
    front.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && card.classList.contains('is-flipped')) { e.stopPropagation(); shut(); }
    });
  }

  function initAll() {
    document.querySelectorAll('.aic__scroller').forEach(initScroller);
    document.querySelectorAll('[data-aic-card]').forEach(initFlip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.aic__scroller').forEach(initScroller);
    e.target.querySelectorAll('[data-aic-card]').forEach(initFlip);
  });
})();
